import React from 'react';

export default class AssessmentConfidenceResults extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('AssessmentConfidenceResults props', this.props);
		return (
			<ul className="learning-plan-exam-results list-group">
				{this.renderQuestionsAndAnswers()}
			</ul>
		);
	}

	renderQuestionsAndAnswers() {
		const { questions, entries } = this.props;

		if (!questions || !Array.isArray(questions) || !questions.length) {
			// Return null if questions is not defined or not an array
			return null;
		}

		return entries.map((entry, idx) => {
			if (
				entry &&
				entry.value &&
				entry.value.options &&
				entry.value.options[0]
			) {
				// Find the corresponding question for the current entry
				const question = questions.find(
					(q) => q.question && q.question.id === entry.value.questionId
				);

				// console.log('question', question);

				if (question && question.question && question.question.options) {
					// Find the corresponding response option for the current entry
					const responseOption = question.question.options.find(
						(option) => option.id === entry.value.options[0].id
					);

					// console.log('responseOption', responseOption);

					const firstLabel =
						question && question.question && question.question.labels[0].text;

					const lastLabel =
						question &&
						question.question &&
						question.question.labels[question.question.labels.length - 1].text;

					// console.log('firstLabel', firstLabel);
					// console.log('lastLabel', lastLabel);

					if (responseOption) {
						return (
							<li className="list-group-item" key={idx}>
								<p
									style={{ fontWeight: 'bold' }}
									dangerouslySetInnerHTML={{
										__html: question.question.statement
									}}
								/>
								<p>
									{responseOption.value} out of 10 (On a scale from 1, {' '}
									{firstLabel} to 10, {lastLabel})
								</p>
							</li>
						);
					}
				}
			}

			// Return null if the corresponding question or response option is not found
			return null;
		});
	}
}
